module.exports = "<router-outlet></router-outlet>"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/club-injuries/club-injuries.component.html
// module id = ./src/app/pages/club-injuries/club-injuries.component.html
// module chunks = main